import { render, staticRenderFns } from "./GestionCliente.vue?vue&type=template&id=05dd080f&"
import script from "./GestionCliente.vue?vue&type=script&lang=js&"
export * from "./GestionCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports